import {DescriptionText, FlexContainer, H1Text, H2Text, Text, Hr} from "../../../../../design";
import React from "react";
import {AmountDivideByHundred} from "../../../../../helper";
import SmallScreenHeader from "../../../../../components/smallscreen/header";
import currencyformatter from "../../../../../utils/currencyformatter";
import getformatteddate from "../../../../../utils/getformatteddate";

type Props = {
  subscription: Object,
  timeZone: string,
  cancelUrlLink: String,
}

const Header = (props:Props) => {
  const {subscription, timeZone, cancelUrlLink } = props;
  
  const customContainerProps = {
    // borderWidth: '5px !important',
    // borderColor: '#000 !important',
    // borderStyle: 'solid !important',
    borderRadius: '10px !important',
    width: '100%',
    padding: '5% !important',
    backgroundColor: '#fff',
  };

  const customFlexContainerProps = {
    width: '100%',
  }

  const customPrimaryHeadingProps = {
    fontWeight: 'bold',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '20px',
  };

  const customSecondaryHeadingProps = {
    fontWeight: 'bold',
    textTransform: 'none',
    marginRight: '10px',
  }

  const customDescriptionProps = {
    fontSize: '18px',
    whiteSpace: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  
  return (
    <SmallScreenHeader cancelUrlLink={cancelUrlLink}>
      <FlexContainer {...customContainerProps}>
        <H1Text>
          Add Payment Method
        </H1Text>
        <Hr/>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Payment For
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {subscription && subscription.description}
          </DescriptionText>
        </FlexContainer>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Amount Payable
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {subscription ? `${currencyformatter(AmountDivideByHundred(subscription.planAmount * subscription.planQuantity), subscription.currency && subscription.currency.name)}` : null }
          </DescriptionText>
        </FlexContainer>
        <FlexContainer {...customFlexContainerProps}>
          <Text
            hidden={!(subscription && (subscription.totalSuccessfulPayments === 0) && (subscription.upfrontAmount !== 0))}
            fontSize="12px"
            marginBottom="20px"
            color="#6b6c6f"
            lineHeight="21px"
          >
            A one-time upfront charge of&nbsp;<span style={{fontWeight:"600", color: "black"}}>
                {subscription && currencyformatter(AmountDivideByHundred(subscription.upfrontAmount), subscription.currency && subscription.currency.name)}
              </span>&nbsp;will be added to the first payment.
          </Text>
        </FlexContainer>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Next Payment Due on
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {subscription && subscription.nextPaymentDate && getformatteddate(subscription.nextPaymentDate, timeZone)}
          </DescriptionText>
        </FlexContainer>
      </FlexContainer>
    </SmallScreenHeader>
  )
};

export default Header;
